<div className="footer">
  <div className="footer-div">
    <span id="link"><a href="https://github.com/Kalsyc">GitHub</a></span>
    <span id="link"><a href="https://linkedin.com/in/kalsyc">LinkedIn</a></span>
  </div>
  <div className="footer-div">
    <span>Email: kalsycofficial@gmail.com</span>
  </div>
  <div className="footer-div">
    <div className="footer-text">
      (c) Sim Jun Yuen, Darren 2021
    </div>
  </div>
</div>
